import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgBusinessUnit = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <path
      fill={_.color}
      d="M8.003 7.834q1.22 0 2.383-.137a15.3 15.3 0 0 0 2.313-.47A14.5 14.5 0 0 0 15 6.353v-.585q0-1.113-.484-1.654-.484-.55-1.459-.55H11.19v-.57q0-1.02-.458-1.503-.453-.49-1.302-.491H6.57q-.805 0-1.283.491-.471.485-.471 1.503v.57H2.943q-.969 0-1.459.55Q1 4.654 1 5.768v.585a14.8 14.8 0 0 0 4.608 1.344q1.17.137 2.395.137M5.79 3.564v-.65q0-.411.201-.635.202-.224.566-.224h2.886q.37 0 .572.224.201.223.201.635v.65zM2.943 15h10.115q.974 0 1.458-.549.484-.55.484-1.654v-5.26A17.2 17.2 0 0 1 11.423 8.6q-.874.15-1.748.224v.585q0 .787-.697.787H7.022q-.69 0-.691-.787v-.585A20 20 0 0 1 4.57 8.6a18 18 0 0 1-1.767-.42A18 18 0 0 1 1 7.539v5.259q0 1.105.484 1.654.49.549 1.459.549"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgBusinessUnit);
export default ForwardRef;
